<template>
  <div class="person main_top">
    <div class="person_container flex">
        <div class="person_menu lg_hiddle" >
            <div class="menu_top">
                <div class="top_head">
                    <div class="hand_icon"><img :src="userInfo.image" alt=""></div>
                    <div class="hand_id">{{ userInfo.nickName }}</div>
                </div>
                <!-- <div class="top_tabs flex">
                    <div class="tab_item">
                        <div class="item_content">$0.00</div>
                        <div class="item_name">My Balance</div>
                    </div>
                    <div class="tab_item">
                        <div class="item_content flex_center">
                            <div class="item_icon"><img src="../../assets/icon/point.jpg" alt=""></div>
                            <div class="item_msg">0</div>
                        </div>
                        <div class="item_name">My Points</div>
                    </div>
                </div> -->
            </div>
            <div class="menu_bot">
                <div class="menu_list">
                    <div class="menu_tab flex_sb " @click="menuTab='3'" :class="[menuTab==3?'is_active':'']">
                        <div class="tab_title flex_center">
                            <div class="tab_icon flex_center"><svg data-v-7a9cf665="" data-v-36e0b530="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; fill: currentcolor; margin-right: 12px;"><path d="M7.54004 13.2849C7.54004 12.8706 7.87583 12.5349 8.29004 12.5349H12.251C12.6652 12.5349 13.001 12.8706 13.001 13.2849C13.001 13.6991 12.6652 14.0349 12.251 14.0349H8.29004C7.87583 14.0349 7.54004 13.6991 7.54004 13.2849Z"></path><path d="M8.27539 8.01289C7.86118 8.01289 7.52539 8.34867 7.52539 8.76289C7.52539 9.1771 7.86118 9.51289 8.27539 9.51289L15.7266 9.51289C16.1408 9.51289 16.4766 9.1771 16.4766 8.76289C16.4766 8.34867 16.1408 8.01289 15.7266 8.01289L8.27539 8.01289Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.46484 6.24137C3.46484 4.1703 5.14378 2.49137 7.21484 2.49137H16.7842C18.8552 2.49137 20.5342 4.1703 20.5342 6.24137V18.075C20.5342 20.146 18.8552 21.825 16.7842 21.825H7.21484C5.14378 21.825 3.46484 20.146 3.46484 18.075V6.24137ZM7.21484 3.99137C5.9722 3.99137 4.96484 4.99873 4.96484 6.24137V18.075C4.96484 19.3176 5.9722 20.325 7.21484 20.325H16.7842C18.0268 20.325 19.0342 19.3176 19.0342 18.075V6.24137C19.0342 4.99873 18.0268 3.99137 16.7842 3.99137H7.21484Z"></path></svg></div>
                            <div class="tab_name">{{ $t('key93') }}</div>
                        </div>     
                    </div>
                    <div class="menu_tab flex_sb" @click="menuTab='5'" :class="[menuTab==5?'is_active':'']">
                        <div class="tab_title flex_center">
                            <div class="tab_icon flex_center"><svg data-v-7a9cf665="" data-v-36e0b530="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; fill: currentcolor; margin-right: 12px;"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9995 2.35498C9.58627 2.35498 7.63 4.31125 7.63 6.72443C7.63 9.1376 9.58627 11.0939 11.9995 11.0939C14.4126 11.0939 16.3689 9.1376 16.3689 6.72443C16.3689 4.31125 14.4126 2.35498 11.9995 2.35498ZM9.13 6.72443C9.13 5.13968 10.4147 3.85498 11.9995 3.85498C13.5842 3.85498 14.8689 5.13968 14.8689 6.72443C14.8689 8.30918 13.5842 9.59387 11.9995 9.59387C10.4147 9.59387 9.13 8.30918 9.13 6.72443Z"></path><path d="M4.52832 17.7579C4.52832 15.963 5.98339 14.5079 7.77832 14.5079H10.6323C11.0465 14.5079 11.3823 14.1721 11.3823 13.7579C11.3823 13.3437 11.0465 13.0079 10.6323 13.0079H7.77832C5.15497 13.0079 3.02832 15.1345 3.02832 17.7579V18.2824C3.02832 19.8012 4.25954 21.0324 5.77832 21.0324H10.6323C11.0465 21.0324 11.3823 20.6966 11.3823 20.2824C11.3823 19.8682 11.0465 19.5324 10.6323 19.5324H5.77832C5.08797 19.5324 4.52832 18.9728 4.52832 18.2824V17.7579Z"></path><path d="M17.3375 16.0442C16.7903 16.0442 16.3467 16.4878 16.3467 17.035C16.3467 17.5823 16.7903 18.0258 17.3375 18.0258C17.8847 18.0258 18.3283 17.5823 18.3283 17.035C18.3283 16.4878 17.8847 16.0442 17.3375 16.0442Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16.9626 11.821C17.1947 11.687 17.4806 11.687 17.7126 11.821L21.6655 14.1032C21.8976 14.2372 22.0405 14.4848 22.0405 14.7527V19.3171C22.0405 19.5851 21.8976 19.8327 21.6655 19.9666L17.7126 22.2488C17.4806 22.3828 17.1947 22.3828 16.9626 22.2488L13.0098 19.9666C12.7777 19.8327 12.6348 19.5851 12.6348 19.3171V14.7527C12.6348 14.4848 12.7777 14.2372 13.0098 14.1032L16.9626 11.821ZM14.1348 15.1857V18.8841L17.3376 20.7333L20.5405 18.8841L20.5405 15.1857L17.3376 13.3366L14.1348 15.1857Z"></path></svg></div>
                            <div class="tab_name">{{ $t('key94') }}</div>
                        </div>     
                    </div>
                    <div class="menu_tab flex_sb" @click="toPage('/faqs')" :class="[menuTab==6?'is_active':'']">
                        <div class="tab_title flex_center">
                            <div class="tab_icon flex_center"><svg data-v-7a9cf665="" data-v-36e0b530="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; fill: currentcolor; margin-right: 12px;"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.15332 12C4.15332 7.6664 7.6664 4.15332 12 4.15332C16.3336 4.15332 19.8467 7.6664 19.8467 12C19.8467 16.3336 16.3336 19.8467 12 19.8467C7.6664 19.8467 4.15332 16.3336 4.15332 12ZM12 2.65332C6.83797 2.65332 2.65332 6.83797 2.65332 12C2.65332 17.162 6.83797 21.3467 12 21.3467C17.162 21.3467 21.3467 17.162 21.3467 12C21.3467 6.83797 17.162 2.65332 12 2.65332ZM12.0007 8.44543C10.9405 8.44543 10.0811 9.30488 10.0811 10.3651C10.0811 10.7793 9.74527 11.1151 9.33105 11.1151C8.91684 11.1151 8.58105 10.7793 8.58105 10.3651C8.58105 8.47645 10.1121 6.94543 12.0007 6.94543C12.9751 6.94543 13.8405 7.26487 14.463 7.89548C15.0844 8.52496 15.3947 9.39437 15.3947 10.3651C15.3947 11.395 14.9182 12.0434 14.352 12.5322C14.1246 12.7285 13.8688 12.9111 13.6372 13.0763L13.6372 13.0763L13.534 13.1501C13.2645 13.3434 13.0151 13.5287 12.7838 13.7439C12.7771 13.7502 12.7507 13.7822 12.7507 13.8562V14.4983C12.7507 14.9125 12.4149 15.2483 12.0007 15.2483C11.5865 15.2483 11.2507 14.9125 11.2507 14.4983V13.8562C11.2507 13.4327 11.4045 12.9784 11.762 12.6458C12.0681 12.361 12.384 12.129 12.6599 11.9311L12.7705 11.852C13.0076 11.6825 13.2008 11.5444 13.3718 11.3968C13.7227 11.0938 13.8947 10.8274 13.8947 10.3651C13.8947 9.71475 13.6917 9.24936 13.3955 8.94927C13.1004 8.65031 12.6437 8.44543 12.0007 8.44543ZM11.186 16.8741C11.186 16.4243 11.5506 16.0596 12.0004 16.0596C12.4502 16.0596 12.8148 16.4243 12.8148 16.8741C12.8148 17.3238 12.4502 17.6885 12.0004 17.6885C11.5506 17.6885 11.186 17.3238 11.186 16.8741Z"></path></svg></div>
                            <div class="tab_name">{{ $t('key95') }} </div>
                        </div>     
                    </div>
                    <div class="menu_tab flex_sb" @click="menuTab='7'" :class="[menuTab==7?'is_active':'']">
                        <div class="tab_title flex_center">
                            <div class="tab_icon flex_center"><svg data-v-7a9cf665="" data-v-36e0b530="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; fill: currentcolor; margin-right: 12px;"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.4733 2.22038C11.4538 1.7781 12.5769 1.7781 13.5573 2.22038L14.8825 2.81817L16.9573 3.15661C17.8147 3.29646 18.2715 4.24663 17.8453 5.00358L17.2054 6.14004C19.6518 8.02212 21.3976 11.1295 21.3976 14.5421C21.3976 17.1637 20.3195 19.1082 18.55 20.3704C16.8147 21.6081 14.4806 22.1454 11.9992 22.1454C9.51776 22.1454 7.1838 21.6081 5.44876 20.3704C3.67938 19.1082 2.60156 17.1636 2.60156 14.5421C2.60156 11.1759 4.25132 8.09756 6.65146 6.20481L6.11067 4.87172C5.81001 4.13056 6.27313 3.30161 7.06191 3.16911L9.14652 2.81891L10.4733 2.22038ZM7.88769 7.15134H16.0515C18.2839 8.74914 19.8976 11.5239 19.8976 14.5421C19.8976 16.6967 19.0396 18.1787 17.6789 19.1492C16.284 20.1441 14.2939 20.6454 11.9992 20.6454C9.70442 20.6454 7.71457 20.1441 6.31985 19.1492C4.95947 18.1788 4.10156 16.6967 4.10156 14.5421C4.10156 11.5155 5.66694 8.74402 7.88769 7.15134ZM12.9405 3.5877C12.3523 3.32233 11.6784 3.32233 11.0901 3.5877L9.67487 4.22613C9.61614 4.25262 9.55425 4.27144 9.49072 4.28211L7.61784 4.59673L8.04566 5.65134H15.7591L16.3627 4.57944L14.5435 4.28269C14.4787 4.27213 14.4156 4.25311 14.3558 4.22613L12.9405 3.5877ZM14.2577 17.0373C14.6352 16.6367 14.824 16.1282 14.824 15.5118C14.824 15.0264 14.7046 14.6296 14.4657 14.3214C14.2269 14.0132 13.9572 13.782 13.6567 13.6279C13.3562 13.4738 12.9479 13.3005 12.4317 13.1079C11.9617 12.9384 11.615 12.7997 11.3915 12.6918C11.1681 12.5839 10.9986 12.4645 10.883 12.3335C10.7751 12.2026 10.7212 12.0408 10.7212 11.8481C10.7212 11.5785 10.8175 11.3666 11.0101 11.2125C11.2028 11.0584 11.4724 10.9813 11.8191 10.9813C12.2583 10.9813 12.605 11.0969 12.8593 11.3281C13.1135 11.5515 13.2407 11.825 13.2407 12.1486V12.2411C13.2407 12.2796 13.2522 12.3143 13.2753 12.3451C13.3062 12.3682 13.3408 12.3798 13.3794 12.3798H14.6391C14.6776 12.3798 14.7084 12.3682 14.7316 12.3451C14.7624 12.3143 14.7778 12.2796 14.7778 12.2411V12.0677C14.7778 11.4513 14.589 10.9313 14.2115 10.5075C13.8339 10.076 13.3254 9.7948 12.6859 9.66382C12.6474 9.64841 12.6281 9.6253 12.6281 9.59448L12.6397 8.72768C12.6397 8.68916 12.6243 8.65834 12.5935 8.63523C12.5704 8.60441 12.5395 8.589 12.501 8.589H11.3453C11.3068 8.589 11.2721 8.60441 11.2413 8.63523C11.2182 8.65834 11.2066 8.68916 11.2066 8.72768L11.2297 9.57136C11.2297 9.60218 11.2105 9.62529 11.1719 9.6407C10.5633 9.75628 10.0779 10.0105 9.71572 10.4035C9.3613 10.7887 9.18409 11.278 9.18409 11.8712C9.18409 12.3412 9.29967 12.738 9.53081 13.0616C9.76966 13.3775 10.0586 13.6279 10.3976 13.8129C10.7366 13.9978 11.1565 14.1788 11.6573 14.356C12.0965 14.5256 12.4163 14.6604 12.6166 14.7606C12.8246 14.853 12.9864 14.9647 13.102 15.0957C13.2176 15.219 13.2753 15.3731 13.2753 15.558C13.2753 15.8123 13.179 16.028 12.9864 16.2052C12.8015 16.3747 12.5126 16.4595 12.1196 16.4595C11.6496 16.4595 11.2798 16.3554 11.0101 16.1474C10.7405 15.9317 10.6056 15.6697 10.6056 15.3615V15.1882C10.6056 15.1496 10.5902 15.1188 10.5594 15.0957C10.5363 15.0649 10.5055 15.0495 10.4669 15.0495H9.21876C9.18024 15.0495 9.14557 15.0649 9.11475 15.0957C9.09164 15.1188 9.08008 15.1496 9.08008 15.1882V15.4424C9.08008 16.0588 9.26499 16.5712 9.63482 16.9795C10.0124 17.3879 10.5286 17.6576 11.1835 17.7885C11.222 17.804 11.2413 17.8271 11.2413 17.8579L11.2297 18.6207C11.2297 18.6592 11.2413 18.69 11.2644 18.7131C11.2952 18.7439 11.3299 18.7593 11.3684 18.7593H12.5241C12.5627 18.7593 12.5935 18.7439 12.6166 18.7131C12.6474 18.69 12.6628 18.6592 12.6628 18.6207L12.6513 17.8694C12.6513 17.8386 12.6705 17.8155 12.709 17.8001C13.364 17.6922 13.8802 17.438 14.2577 17.0373Z"></path></svg></div>
                            <div class="tab_name">{{ localName }} {{ $t('key34') }}</div>
                        </div>     
                    </div>
                </div>
            </div>
        </div>
        <div class="person_content hidden-xs-only">
            <div class="" v-if="menuTab==3">
                <order></order>
            </div>
            <div class="" v-if="menuTab==5">
               <account-set></account-set>
            </div>
            <div class="guide_content" v-if="menuTab==7">
                <guide></guide>
            </div>   
        </div>
        <!-- mobile -->
         <div class="mobile_container hidden-sm-and-up">
            <div class="header_content">
                <div class="header_user flex_sb" @click="toPage('/accountSet')">
                    <div class="user_cont flex">
                        <div class="user_avatar"><img :src="userInfo.image" alt=""></div> 
                        <div class="user_name flex_center">{{ userInfo.nickName }}</div>
                    </div>
                    <div class="iconfont more_icon icon-enter-line-free flex_center"></div>
                </div>
                <div class="header_row flex">
                    <div class="col_tab">
                        <div class="tab_top">{{currency.remark}}0.00</div>
                        <div class="tab_bot">{{ $t('key96') }}</div>
                    </div>
                    <div class="col_tab">
                        <div class="tab_top flex icon_top"><div class="piont_icon"><img src="../../assets/icon/point.jpg" alt=""></div>0.00</div>
                        <div class="tab_bot">{{ $t('key97') }}</div>
                    </div>
                    <div class="col_tab">
                        <div class="tab_top">3</div>
                        <div class="tab_bot">{{ $t('key98') }}</div>
                    </div>
                </div>
                <div class="header_order_wrapper" >
                    <div class="header_order">
                        <div class="header_row">
                            <div class="order_col" @click="toPage('/order')">
                                <div class="col_icon icon_all"></div>
                                <div class="col_name">{{ $t('key00') }}</div>
                            </div>
                            <div class="order_col" @click="toPage('/order')">
                                <div class="col_icon icon_info"></div>
                                <div class="col_name">{{ $t('key99') }}</div>
                            </div>
                            <div class="order_col" @click="toPage('/order')">
                                <div class="col_icon incon_pro"></div>
                                <div class="col_name">{{ $t('key100') }}</div>
                            </div>
                            <div class="order_col" @click="toPage('/order')">
                                <div class="col_icon icon_refund"></div>
                                <div class="col_name">{{ $t('key101') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="personal_list">
                <div class="list_item flex_sb" @click="toPage('/accountSet')">
                    <div class="item_name flex">
                        <div class="icon_show flex_center"><svg data-v-7a9cf665="" data-v-36e0b530="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; fill: currentcolor; "><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9995 2.35498C9.58627 2.35498 7.63 4.31125 7.63 6.72443C7.63 9.1376 9.58627 11.0939 11.9995 11.0939C14.4126 11.0939 16.3689 9.1376 16.3689 6.72443C16.3689 4.31125 14.4126 2.35498 11.9995 2.35498ZM9.13 6.72443C9.13 5.13968 10.4147 3.85498 11.9995 3.85498C13.5842 3.85498 14.8689 5.13968 14.8689 6.72443C14.8689 8.30918 13.5842 9.59387 11.9995 9.59387C10.4147 9.59387 9.13 8.30918 9.13 6.72443Z"></path><path d="M4.52832 17.7579C4.52832 15.963 5.98339 14.5079 7.77832 14.5079H10.6323C11.0465 14.5079 11.3823 14.1721 11.3823 13.7579C11.3823 13.3437 11.0465 13.0079 10.6323 13.0079H7.77832C5.15497 13.0079 3.02832 15.1345 3.02832 17.7579V18.2824C3.02832 19.8012 4.25954 21.0324 5.77832 21.0324H10.6323C11.0465 21.0324 11.3823 20.6966 11.3823 20.2824C11.3823 19.8682 11.0465 19.5324 10.6323 19.5324H5.77832C5.08797 19.5324 4.52832 18.9728 4.52832 18.2824V17.7579Z"></path><path d="M17.3375 16.0442C16.7903 16.0442 16.3467 16.4878 16.3467 17.035C16.3467 17.5823 16.7903 18.0258 17.3375 18.0258C17.8847 18.0258 18.3283 17.5823 18.3283 17.035C18.3283 16.4878 17.8847 16.0442 17.3375 16.0442Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16.9626 11.821C17.1947 11.687 17.4806 11.687 17.7126 11.821L21.6655 14.1032C21.8976 14.2372 22.0405 14.4848 22.0405 14.7527V19.3171C22.0405 19.5851 21.8976 19.8327 21.6655 19.9666L17.7126 22.2488C17.4806 22.3828 17.1947 22.3828 16.9626 22.2488L13.0098 19.9666C12.7777 19.8327 12.6348 19.5851 12.6348 19.3171V14.7527C12.6348 14.4848 12.7777 14.2372 13.0098 14.1032L16.9626 11.821ZM14.1348 15.1857V18.8841L17.3376 20.7333L20.5405 18.8841L20.5405 15.1857L17.3376 13.3366L14.1348 15.1857Z"></path></svg></div>
                        <div>{{ $t('key94') }}</div>
                    </div>
                    <div class="item_more flex" >
                        <div class="more_icon iconfont icon-enter-line-free"></div>
                    </div>
                </div>
                <div class="list_item flex_sb" @click="setLang()">
                    <div class="item_name flex">
                        <div class="icon_show flex_center"><svg t="1732501240155" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5486" width="20" height="20"><path d="M480 64C214.848 64 0 278.848 0 544S214.848 1024 480 1024 960 809.152 960 544 745.152 64 480 64zM893.696 512l-126.784 0c-5.504-138.56-45.952-260.992-107.136-342.72C790.144 231.936 881.984 360.64 893.696 512zM702.4 512 512 512 512 132.736C614.848 160.128 694.336 317.312 702.4 512zM448 132.736 448 512 257.6 512C265.664 317.312 345.152 160.128 448 132.736zM300.288 169.28C239.04 251.008 198.656 373.44 193.152 512L66.304 512C78.016 360.64 169.856 231.936 300.288 169.28zM66.304 576l126.784 0c5.504 138.56 45.952 260.992 107.136 342.72C169.856 856.064 78.016 727.36 66.304 576zM257.6 576 448 576l0 379.264C345.152 927.872 265.664 770.688 257.6 576zM512 955.264 512 576l190.4 0C694.336 770.688 614.848 927.872 512 955.264zM659.712 918.72c61.248-81.728 101.632-204.16 107.136-342.72l126.784 0C881.984 727.36 790.144 856.064 659.712 918.72z" p-id="5487" fill="#000000"></path></svg></div>
                        <div>{{ $t('key5') }} & {{ $t('key6') }}</div>
                    </div>
                    <div class="item_more flex" >
                        <div class="more_icon iconfont icon-enter-line-free"></div>
                    </div>
                </div>
                <div class="list_item flex_sb" @click="toPage('/faqs')">
                    <div class="item_name flex">
                        <div class="icon_show flex_center"><svg data-v-7a9cf665="" data-v-36e0b530="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; fill: currentcolor; "><path fill-rule="evenodd" clip-rule="evenodd" d="M4.15332 12C4.15332 7.6664 7.6664 4.15332 12 4.15332C16.3336 4.15332 19.8467 7.6664 19.8467 12C19.8467 16.3336 16.3336 19.8467 12 19.8467C7.6664 19.8467 4.15332 16.3336 4.15332 12ZM12 2.65332C6.83797 2.65332 2.65332 6.83797 2.65332 12C2.65332 17.162 6.83797 21.3467 12 21.3467C17.162 21.3467 21.3467 17.162 21.3467 12C21.3467 6.83797 17.162 2.65332 12 2.65332ZM12.0007 8.44543C10.9405 8.44543 10.0811 9.30488 10.0811 10.3651C10.0811 10.7793 9.74527 11.1151 9.33105 11.1151C8.91684 11.1151 8.58105 10.7793 8.58105 10.3651C8.58105 8.47645 10.1121 6.94543 12.0007 6.94543C12.9751 6.94543 13.8405 7.26487 14.463 7.89548C15.0844 8.52496 15.3947 9.39437 15.3947 10.3651C15.3947 11.395 14.9182 12.0434 14.352 12.5322C14.1246 12.7285 13.8688 12.9111 13.6372 13.0763L13.6372 13.0763L13.534 13.1501C13.2645 13.3434 13.0151 13.5287 12.7838 13.7439C12.7771 13.7502 12.7507 13.7822 12.7507 13.8562V14.4983C12.7507 14.9125 12.4149 15.2483 12.0007 15.2483C11.5865 15.2483 11.2507 14.9125 11.2507 14.4983V13.8562C11.2507 13.4327 11.4045 12.9784 11.762 12.6458C12.0681 12.361 12.384 12.129 12.6599 11.9311L12.7705 11.852C13.0076 11.6825 13.2008 11.5444 13.3718 11.3968C13.7227 11.0938 13.8947 10.8274 13.8947 10.3651C13.8947 9.71475 13.6917 9.24936 13.3955 8.94927C13.1004 8.65031 12.6437 8.44543 12.0007 8.44543ZM11.186 16.8741C11.186 16.4243 11.5506 16.0596 12.0004 16.0596C12.4502 16.0596 12.8148 16.4243 12.8148 16.8741C12.8148 17.3238 12.4502 17.6885 12.0004 17.6885C11.5506 17.6885 11.186 17.3238 11.186 16.8741Z"></path></svg></div>
                        <div>{{ $t('key95') }}</div>
                    </div>
                    <div class="item_more flex" >
                        <div class="more_icon iconfont icon-enter-line-free"></div>
                    </div>
                </div>
                <div class="list_item flex_sb" @click="toPage('/guide')">
                    <div class="item_name flex">
                        <div class="icon_show flex_center"><svg data-v-7a9cf665="" data-v-36e0b530="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; fill: currentcolor; "><path fill-rule="evenodd" clip-rule="evenodd" d="M10.4733 2.22038C11.4538 1.7781 12.5769 1.7781 13.5573 2.22038L14.8825 2.81817L16.9573 3.15661C17.8147 3.29646 18.2715 4.24663 17.8453 5.00358L17.2054 6.14004C19.6518 8.02212 21.3976 11.1295 21.3976 14.5421C21.3976 17.1637 20.3195 19.1082 18.55 20.3704C16.8147 21.6081 14.4806 22.1454 11.9992 22.1454C9.51776 22.1454 7.1838 21.6081 5.44876 20.3704C3.67938 19.1082 2.60156 17.1636 2.60156 14.5421C2.60156 11.1759 4.25132 8.09756 6.65146 6.20481L6.11067 4.87172C5.81001 4.13056 6.27313 3.30161 7.06191 3.16911L9.14652 2.81891L10.4733 2.22038ZM7.88769 7.15134H16.0515C18.2839 8.74914 19.8976 11.5239 19.8976 14.5421C19.8976 16.6967 19.0396 18.1787 17.6789 19.1492C16.284 20.1441 14.2939 20.6454 11.9992 20.6454C9.70442 20.6454 7.71457 20.1441 6.31985 19.1492C4.95947 18.1788 4.10156 16.6967 4.10156 14.5421C4.10156 11.5155 5.66694 8.74402 7.88769 7.15134ZM12.9405 3.5877C12.3523 3.32233 11.6784 3.32233 11.0901 3.5877L9.67487 4.22613C9.61614 4.25262 9.55425 4.27144 9.49072 4.28211L7.61784 4.59673L8.04566 5.65134H15.7591L16.3627 4.57944L14.5435 4.28269C14.4787 4.27213 14.4156 4.25311 14.3558 4.22613L12.9405 3.5877ZM14.2577 17.0373C14.6352 16.6367 14.824 16.1282 14.824 15.5118C14.824 15.0264 14.7046 14.6296 14.4657 14.3214C14.2269 14.0132 13.9572 13.782 13.6567 13.6279C13.3562 13.4738 12.9479 13.3005 12.4317 13.1079C11.9617 12.9384 11.615 12.7997 11.3915 12.6918C11.1681 12.5839 10.9986 12.4645 10.883 12.3335C10.7751 12.2026 10.7212 12.0408 10.7212 11.8481C10.7212 11.5785 10.8175 11.3666 11.0101 11.2125C11.2028 11.0584 11.4724 10.9813 11.8191 10.9813C12.2583 10.9813 12.605 11.0969 12.8593 11.3281C13.1135 11.5515 13.2407 11.825 13.2407 12.1486V12.2411C13.2407 12.2796 13.2522 12.3143 13.2753 12.3451C13.3062 12.3682 13.3408 12.3798 13.3794 12.3798H14.6391C14.6776 12.3798 14.7084 12.3682 14.7316 12.3451C14.7624 12.3143 14.7778 12.2796 14.7778 12.2411V12.0677C14.7778 11.4513 14.589 10.9313 14.2115 10.5075C13.8339 10.076 13.3254 9.7948 12.6859 9.66382C12.6474 9.64841 12.6281 9.6253 12.6281 9.59448L12.6397 8.72768C12.6397 8.68916 12.6243 8.65834 12.5935 8.63523C12.5704 8.60441 12.5395 8.589 12.501 8.589H11.3453C11.3068 8.589 11.2721 8.60441 11.2413 8.63523C11.2182 8.65834 11.2066 8.68916 11.2066 8.72768L11.2297 9.57136C11.2297 9.60218 11.2105 9.62529 11.1719 9.6407C10.5633 9.75628 10.0779 10.0105 9.71572 10.4035C9.3613 10.7887 9.18409 11.278 9.18409 11.8712C9.18409 12.3412 9.29967 12.738 9.53081 13.0616C9.76966 13.3775 10.0586 13.6279 10.3976 13.8129C10.7366 13.9978 11.1565 14.1788 11.6573 14.356C12.0965 14.5256 12.4163 14.6604 12.6166 14.7606C12.8246 14.853 12.9864 14.9647 13.102 15.0957C13.2176 15.219 13.2753 15.3731 13.2753 15.558C13.2753 15.8123 13.179 16.028 12.9864 16.2052C12.8015 16.3747 12.5126 16.4595 12.1196 16.4595C11.6496 16.4595 11.2798 16.3554 11.0101 16.1474C10.7405 15.9317 10.6056 15.6697 10.6056 15.3615V15.1882C10.6056 15.1496 10.5902 15.1188 10.5594 15.0957C10.5363 15.0649 10.5055 15.0495 10.4669 15.0495H9.21876C9.18024 15.0495 9.14557 15.0649 9.11475 15.0957C9.09164 15.1188 9.08008 15.1496 9.08008 15.1882V15.4424C9.08008 16.0588 9.26499 16.5712 9.63482 16.9795C10.0124 17.3879 10.5286 17.6576 11.1835 17.7885C11.222 17.804 11.2413 17.8271 11.2413 17.8579L11.2297 18.6207C11.2297 18.6592 11.2413 18.69 11.2644 18.7131C11.2952 18.7439 11.3299 18.7593 11.3684 18.7593H12.5241C12.5627 18.7593 12.5935 18.7439 12.6166 18.7131C12.6474 18.69 12.6628 18.6592 12.6628 18.6207L12.6513 17.8694C12.6513 17.8386 12.6705 17.8155 12.709 17.8001C13.364 17.6922 13.8802 17.438 14.2577 17.0373Z"></path></svg></div>
                        <div>{{ localName }} {{ $t('key34') }}</div>
                    </div>
                    <div class="item_more flex" >
                        <div class="more_icon iconfont icon-enter-line-free"></div>
                    </div>
                </div>
                <div class="list_item flex_sb" @click="toPage('/aboutus')">
                    <div class="item_name flex">
                        <div class="icon_show flex_center"><svg t="1732501661654" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5898" width="20" height="20" ><path d="M558.656 443.04h-93.12c-12.864 0-23.264 10.432-23.264 23.232v282.72c0 12.832 10.432 23.232 23.264 23.232h93.12c12.864 0 23.264-10.432 23.264-23.232v-282.72c0.032-12.832-10.4-23.232-23.264-23.232z" p-id="5899" fill="#000000"></path><path d="M512 0C229.792 0 0 229.664 0 512.032S229.728 1024 512 1024c282.304 0 512-229.6 512-511.968S794.368 0 512 0z m-0.448 958.912c-246.784 0-447.456-200.768-447.456-447.456 0-246.848 200.704-447.552 447.456-447.552s447.52 200.672 447.52 447.552c0.032 246.72-200.736 447.456-447.52 447.456z" p-id="5900" fill="#000000"></path><path d="M512.128 250.688c-19.296 0-38.496 7.936-52.16 21.568s-21.6 32.8-21.6 52.064c0 19.264 7.936 38.464 21.6 52.064s32.832 21.568 52.16 21.568 38.496-7.936 52.16-21.568c13.632-13.632 21.6-32.8 21.6-52.064s-7.936-38.464-21.6-52.064c-13.632-13.632-32.832-21.568-52.16-21.568z" p-id="5901" fill="#000000"></path></svg></div>
                        <div>{{ $t('key102') }}</div>
                    </div>
                    <div class="item_more flex" >
                        <div class="more_icon iconfont icon-enter-line-free"></div>
                    </div>
                </div>
            </div>
         </div>
    </div>
  </div>
</template>

<script>
import guide from '../page/guide.vue'
import accountSet from './accountSet.vue';
import order from './order.vue'
export default {
    components:{
        guide,
        accountSet,
        order
    },
    data(){
        return{
            orderList:[1],
            menuTab:'5', 
            userContent:[
                // {name:'My Balance',id:1,path:'',content:'$0.00'},
                // {name:'My Points',id:2,path:'',content:'0.00'},
                {name:'Buy History',id:3,path:'',content:''},
                // {name:'My Coupon ',id:4,path:'',content:''},
                {name:'Account Settings ',id:5,path:'',content:''},
                {name:'Help Center ',id:6,path:'',content:''},
                {name:'playsave.com Affiliate Program ',id:7,path:'',content:''},
                // {name:'Log out',id:8,path:'',content:''},
            ],
        }
    },
    created(){
        let menuTab = this.$route.query.tabId
        if(menuTab){
            this.menuTab = menuTab
        }
      
    },
    methods:{
       
        toPage(path){
            let lang = localStorage.getItem('lang')
            this.$router.push(path+'/'+lang)
        },
        setLang(){
            this.$store.commit('setLang_flag',true)
        }
    },
    computed:{
        currency(){return this.$store.state.currency},
        userInfo(){ return this.$store.state.userInfo},
        localName(){return this.$store.state.localName}
    }
}
</script>

<style lang="scss" scoped>
.person{
    margin-top:30px;
    .person_container{
        .person_menu{
            width: 296px;
            margin-right: 16px;
            height: 100%;
            border-radius: 4px;
            background: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #282828;
            font-size: 14px;
            overflow: auto;
            position: -webkit-sticky;
            position: sticky;
            top: 80px;
            color:#0f0f0f;
            .menu_top{ 
                margin-top: 28px;
                margin-bottom: 16px;
                width: 100%;
                .top_head{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .hand_icon{
                        width: 80px;
                        height: 80px;
                        border-radius: 50%;
                        margin-bottom: 8px;
                        overflow: hidden;
                    }
                    .hand_id{
                        margin-bottom: 8px;
                        font-size: 14px;
                    }
                    
                }
                .top_tabs{
                    margin-bottom: 16px;
                    margin-top: 16px;
                    // border-bottom: 1px solid #e8e9ed;
                    width: 100%;
                    .tab_item{
                        width: 50%;
                        color:#282828;
                        cursor: pointer;
                        position: relative;
                        &:first-child{
                             border-right: 1px solid #e8e9ed;
                           
                        }
                        &:hover{
                            opacity: 0.7;
                        }
                        .item_content{
                            font-size: 20px;
                            font-weight: 600;
                            line-height: 20px;
                        }
                        .item_name{
                            font-size:14px;
                            color:#5e626b;
                            line-height: 20px;
                            margin-top:4px;
                        }
                        .item_icon{
                            width:16px;
                            height: 16px;
                            margin-right:4px;
                            border-radius: 50%;
                            overflow: hidden;
                        }
                    }
                }
            }
            .menu_bot{
                width: 100%;
                padding: 8px 4px;
                border-top: 1px solid #e8e9ed;
                .menu_list{
                    .menu_tab{
                        width: 100%;
                        height: 44px;
                        padding: 0 12px;
                        color: #2e3033;
                        border-left: 3px solid transparent;
                        cursor: pointer;
                        position: relative;
                        margin-bottom: 3px;
                        font-size: 15px;
                        line-height: 24px;
                        &:hover{
                            background:#f5f6f7;
                            
                        }
                        .tab_icon{
                            height: 24px;
                        }
                        text-align: left;
                    }
                    .is_active{
                        background: #fff5d5;
                        font-weight: 600;
                        color: #0f0f0f;
                        border-left: 3px solid #fc0;
                    }
                }
            }
        }
        .person_content{
            flex: 1 1 0;
            max-width: 888px;
            width: 100%;
            margin:0 auto;
            // order 
           margin-top:-96px;
            
           
            
        }
        /* mobile  */
        .mobile_container{
            width: 100%;
            .header_content{
                margin:0 -16px;
                background: url(https://static.playsave.com/src/img/img_playsave_bg.dabe53a4.png) no-repeat #fff;
                background-size: contain;
                .header_user{
                    padding:24px 16px;
                    .user_cont{
                        .user_avatar{
                            width:64px;
                            height: 64px;
                            border-radius: 50%;
                            overflow: hidden;
                            margin-right: 10px;
                        }
                        .user_name{
                            font-size: 18px;
                            font-weight: 600;
                            color:#1f2128;
                        }
                    }
                    .more_icon{
                        color:#77808c;
                        font-size: 14px;
                        height: 20px;
                        width: 20px;
                        cursor: pointer;

                    }
                }
                .header_row{
                    justify-content: space-around;
                    padding:40x 0;
                    .col_tab{
                        font-family: BarlowSemiBold;
                        font-weight: 600;
                        font-size: 22px;
                        line-height: 26px;

                        color:#0f0f0f;
                        cursor: pointer;
                        .icon_top{
                            align-items: baseline;
                            .piont_icon{
                                width:16px;
                                height: 16px;
                                margin-right:4px;
                                border-radius: 50%;
                                overflow: hidden;
                            }
                        }
                        .tab_bot{
                            font-size: 13px;
                            line-height: 16px;
                            margin-top: 6px;
                            font-weight: 400;
                            color:#1f2128;
                        }
                    }
                }
                .header_order_wrapper{
                    padding: 16px;
                    .header_order{
                        padding: 0 8px 8px;
                        border: 1px solid #e8e9ed;
                        border-radius: 4px;
                        background: #f8f9fa;
                        .header_row{
                            padding: 16px 0 12px;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            background: transparent;
                            .order_col{
                                .col_icon{
                                    position: relative;
                                    margin: 0 auto;
                                    width: 28px;
                                    height: 28px;
                                    background-repeat: no-repeat;
                                    background-size: contain;
                                   
                                    
                                }
                                .icon_all{
                                    background-image: url(../../static/image/order_1.png);
                                }
                                .icon_info{
                                        background-image: url(../../static/image/order_2.png);
                                }
                                
                                .incon_pro{
                                    background-image: url(../../static/image/order_3.png);
                                }
                                .icon_refund{
                                    background-image: url(../../static/image/order_4.png);
                                }
                                .col_name{
                                    font-size: 12px;
                                    line-height: 16px;
                                    margin-top: 6px;
                                    color: #0f0f0f;
                                    font-weight: 400;
                                }
                            }
                        }
                    }
                }
                

            }
            .personal_list{
                background:#fff;
                margin:0 -16px;
                .list_item{
                    color: #000;
                    font-size: 16px;
                    height: 56px;
                    cursor: pointer;
                    padding:0 16px;
                    &:hover{
                        opacity: 0.6;
                    }
                    .item_name{
                        .icon_show{
                            width: 24px;
                            height: 24px;
                            margin-right:12px;
                        }
                    }
                }
            }
        }
    }
}
@media screen and (max-width:768px){
    .person{
        margin-top:0!important;
    }
}

</style>